import clsx from 'clsx';
import * as React from 'react';
import style from './button.module.scss';

interface ButtonProps {
  handleOnClick?: () => void;
  isSecondary?: boolean;
  isSecondaryEmpty?: boolean;
  disabled?: boolean;
  text?: string;
  form?: string;
  customStyleClass?: any;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const Button: React.FunctionComponent<ButtonProps> = ({
  handleOnClick,
  disabled,
  isSecondary,
  isSecondaryEmpty,
  text,
  form,
  customStyleClass,
  type
}) => {
  return (
    <>
      <button
        form={form}
        onClick={handleOnClick}
        disabled={disabled}
        type={type}
        className={clsx(
          !isSecondary && style.buttonStyle,
          isSecondary && style.buttonStyleSecondary,
          isSecondaryEmpty && style.buttonStyleSecondaryEmpty,
          customStyleClass
        )}
      >
        {text}
      </button>
    </>
  );
};

export default Button;
